const toPrecision = (value: number | string, precision: number) => {
    const numberRep = typeof value === 'string' ? parseFloat(value) : value
    const multiplier = Math.pow(10, precision)
    return Math.round(numberRep * multiplier) / multiplier
}

export default toPrecision
